import React from 'react';
export function Stats() {
  const stats = [{
    value: '200+',
    label: 'Recetas incluidas'
  }, {
    value: '20',
    label: 'Días para ver resultados'
  }, {
    value: '3,800+',
    label: 'Mascotas transformadas'
  }, {
    value: '60%',
    label: 'Ahorro promedio en comida'
  }];
  return <section className="bg-forest-green py-8 md:py-10 px-4 border-y-4 border-gold relative overflow-hidden" data-id="element-296">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(212,160,23,0.1)_0%,transparent_70%)] pointer-events-none" data-id="element-297"></div>
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-298">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-6 gap-x-6 text-center" data-id="element-299">
          {stats.map((stat, idx) => <div key={idx} className={`space-y-2 ${idx !== stats.length - 1 ? 'md:border-r md:border-green-accent/50' : ''}`} data-id="element-300">
              <div className="text-5xl md:text-6xl font-black text-gold font-serif drop-shadow-[0_2px_4px_rgba(0,0,0,0.3)]" data-id="element-301">
                {stat.value}
              </div>
              <div className="text-cream text-xs md:text-sm font-black uppercase tracking-widest px-2" data-id="element-302">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}